import { Alert, Button } from 'antd';
import styled from 'styled-components';
import {
  BlueColors,
  GreenColors,
  MediaQuery,
  NeutralColors,
  SyngentaNavy,
} from 'theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${NeutralColors[0]};
  overflow: hidden;
`;

export const Header = styled.div`
  position: relative;
  height: 232px;
  background-color: ${NeutralColors[0]};
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 460px;
    height: 100%;
    background-color: ${NeutralColors[10]};
  }

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    height: 150px;

    &::after {
      width: 0%;
    }
  }
`;

export const HeaderBackground = styled.div`
  position: absolute;
  bottom: 8px;
  left: 50%;
  width: 1688px;
  height: 1603px;
  border-radius: 1200px;
  background-color: ${SyngentaNavy};
  background-image: url('/assets/cropwise-products.webp');
  background-size: 920px;
  background-position: center;
  transform: translateX(-50%);
  z-index: 1;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    padding: 24px 16px;
    overflow-y: visible;
  }
`;

export const AlertBanner = styled(Alert)`
  margin-bottom: 16px;
  background-color: ${BlueColors[10]} !important;
  border-color: ${BlueColors[60]} !important;
  border-radius: 4px !important;
  padding: 12px 16px !important;

  .anticon {
    color: ${BlueColors[60]} !important;
  }
`;

export const RightSection = styled.div`
  width: 460px;
  padding: 32px;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    width: 100%;
    padding: 24px 16px;
    overflow-y: visible;
  }
  background-color: ${NeutralColors[10]};
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;
`;

export const PrimaryButton = styled(Button)`
  flex: 1;
  height: 40px;
  border-radius: 4px;
  background-color: ${GreenColors[60]} !important;
  border: none !important;
  color: ${NeutralColors[0]} !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;

  &:hover {
    background-color: ${GreenColors[70]} !important;
  }

  &:active {
    background-color: ${GreenColors[80]} !important;
  }
`;

export const SecondaryButton = styled(Button)`
  flex: 1;
  height: 40px;
  border-radius: 4px;
  background-color: ${NeutralColors[0]} !important;
  border: 1px solid ${NeutralColors[30]} !important;
  color: ${NeutralColors[100]} !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;

  &:hover {
    border-color: ${NeutralColors[40]} !important;
    color: ${NeutralColors[100]} !important;
  }
`;
